"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorP2PFieldView = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const index_1 = require("../../../i18n/index");
const field_info_1 = require("../../field.info/field.info");
const vector_manual_field_view_1 = require("./vector.manual.field.view");
exports.VectorP2PFieldView = {
    viewInline(field) {
        return field_info_1.FieldInfo.viewVectorInline(field.value);
    },
    hasDetail(field) {
        return true;
    },
    viewDetail(field) {
        const collection = field.collection;
        const captures = field.getCaptures();
        const p2pMeasurement = core_shared_1.MultiPoint.Points(captures);
        const stats = [
            { name: index_1.T.DISTANCE_VERTICAL, value: Math.abs(p2pMeasurement.vertical) },
            { name: index_1.T.DISTANCE_HORIZONTAL, value: p2pMeasurement.horizontal }
        ];
        return field_info_1.FieldInfo.viewCaptures(collection, captures, stats);
    },
    viewEdit(field, ctrl) {
        return (0, vector_manual_field_view_1.viewVectorManualEdit)(field, ctrl);
    }
};
//# sourceMappingURL=vector.p2p.field.view.js.map